import { ProgressionBar } from '@pelckmans/business-components/components/progression-bar';
import { useTranslation } from 'react-i18next';

type Props = {
  achievable: number;
  achieved: number;
  maximum: number;
  isPending?: boolean;
  pending?: number;
};

export default function ProgressionAndResultBar({
  achievable,
  achieved,
  maximum,
  isPending = false,
  pending = 0,
}: Props) {
  const { t } = useTranslation();

  return (
    <ProgressionBar
      achievable={achievable}
      achieved={achieved}
      maximum={maximum}
      translations={isPending ? { pending: t('BUSINESS_COMPONENTS.PROGRESSION_BAR.PENDING') } : undefined}
      pending={isPending ? maximum : pending}
    />
  );
}
